import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { GroupRouteModel } from 'donor-elf-web/routes/funds/fund/groups/group';

export default class GroupAddToMailchimpController extends Controller {
  @service declare router: RouterService;
  @service declare store: Store;

  @tracked savingMessage?: string;
  @tracked savedMessage?: string;
  @tracked error?: any;

  model!: GroupRouteModel;

  @action
  templateWillDestroy() {
    this.savingMessage = undefined;
    this.savedMessage = undefined;
    this.error = undefined;
  }

  @action
  async syncFirstEmails() {
    this.savingMessage = 'Syncing first emails in this group with MailChimp...';
    try {
      let model = this.store.createRecord('mailchimp-sync-group-email', {
        groupName: this.model.group,
        syncFirstEmails: true,
      });
      await model.save();
      this.savedMessage = 'Synced first emails in this group with MailChimp';
    } catch (e) {
      this.error = e;
    }
  }

  @action
  async syncAllEmails() {
    this.savingMessage = 'Syncing all emails in this group with MailChimp...';
    try {
      let model = this.store.createRecord('mailchimp-sync-group-email', {
        groupName: this.model.group,
        syncAllEmails: true,
      });
      await model.save();
      this.savedMessage = 'Synced all emails in this group with MailChimp';
    } catch (e) {
      this.error = e;
    }
  }
}
